import _styled from "@emotion/styled-base";
/* eslint-disable id-blacklist, no-restricted-imports */
import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
import * as base from './feature-icons.style';
var font = vars.font;
var CommercialIcons = /*#__PURE__*/_styled(base.Icons, {
  target: "eh374z50"
})({
  name: "2imjyh",
  styles: "display:flex;flex-wrap:wrap;"
});
var CommercialValue = /*#__PURE__*/_styled(base.Value, {
  target: "eh374z51"
})("font-weight:normal;font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";");
var commercialItemIcon = /*#__PURE__*/css(base.itemIcon, ";margin:0 4px 0 0;");
var CommercialItem = base.Item;
export { CommercialIcons as Icons, CommercialValue as Value, commercialItemIcon as itemIcon, CommercialItem as Item };